module.exports = __webpack_public_path__ + "static/img/aih3.32f5f9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/aih3.png
// module id = N1lT
// module chunks = 0